import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServiceNotificationIcon, ServiceNotificationItem } from '@brightside-web/desktop/feature/service-notifications';
import { ActionCardConfigInterface, BrightsideUiModule } from '@brightside/brightside-ui';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { FirebaseService } from '@brightside-web/desktop/data-access/shared';
import { getRouteForKey } from '@brightside-web/desktop/data-access/core-services';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
    selector: 'brightside-web-urgent-notification',
    imports: [CommonModule, BrightsideUiModule],
    templateUrl: './urgent-notification-card.component.html',
    styleUrl: './urgent-notification-card.component.scss',
    animations: [
        trigger('slide', [
            transition(':enter', [
                style({ transform: '{{enterTransform}}', opacity: 0 }),
                animate('400ms ease-out', style({ transform: 'translateX(0)', opacity: 1 })),
            ], { params: { enterTransform: 'translateX(100%)' } }),
            transition(':leave', [animate('400ms ease-out', style({ transform: '{{leaveTransform}}', opacity: 0 }))], {
                params: { leaveTransform: 'translateX(-100%)' },
            }),
        ]),
    ]
})
export class UrgentNotificationCardComponent {
  @Input() notificationItem: ServiceNotificationItem;
  actionCardConfig: ActionCardConfigInterface;

  private _translateSvc = inject(TranslateService);
  private _router = inject(Router);
  private _analytics = inject(FirebaseService);

  ngOnInit() {
    this.actionCardConfig = this.mapToActionCardConfig(this.notificationItem);
  }

  mapToActionCardConfig(item: ServiceNotificationItem): ActionCardConfigInterface {
    return {
      label: this._translateSvc.instant(item.copy1),
      title: this._translateSvc.instant(item.copy2),
      body: this._translateSvc.instant(item.copy3),
      labelIcon: ServiceNotificationIcon[item.state] ?? '',
      cardStyle: 'small',
      shadow: !item.read,
      bgColor: '#fef4c4',
      originalItem: item,
      hideCta: item.key === undefined,
    };
  }

  navigate() {
    if (this.actionCardConfig.originalItem?.key) {
      const route = getRouteForKey({ key: this.actionCardConfig.originalItem.key, route: this.actionCardConfig.originalItem.route });
      this._analytics.logEvent('notifications tapped', {
        type: this.actionCardConfig.originalItem.key,
        url: this.actionCardConfig.originalItem.route,
      });
      this._router.navigate([route]);
    }
  }

}
